import React from 'react'
import documentIcon from '../../../../assets/cardEntryIcons/document.svg';
import ErrorBoundary from "../../../Utils/ErrorBoundary"
import ReservationDetailsCard from "./ReservationDetailsCard/ReservationDetailsCard"
import {getCustomSection} from "./customDataUtils"



const customDataCards = [
    {section: "reservation_details", component: ReservationDetailsCard}
]



function CustomDataCard(props) {

    let custom_data = props.order.custom_data

    if (custom_data == null) return null

    let availableCards = customDataCards.filter(card => getCustomSection(custom_data, card.section) != null)

    if (availableCards.length === 0) return null

    return (
        <div className="analysisCard">
            <div style={{display: "flex"}}>
                <img className="cardTitleIconStyle" src={documentIcon} alt="documentIcon Logo" />
                <span className={["blueText", "subtitleSize", "labelSpace"].join(" ")}>Dados Customizáveis</span>
            </div>
            <div className="internalCardContainer" style={{display: "flex", flexWrap: "wrap", margin: "15px -10px 0px -10px"}}>
                {availableCards.map((card, index) => (
                    <div key={index} style={{display: "flex", flexGrow: "1", flexBasis: "350px", padding: "10px"}}>
                        <ErrorBoundary>
                            <card.component custom_data={custom_data}/>
                        </ErrorBoundary>
                    </div>
                ))}
            </div>
        </div>
    )
}



export default CustomDataCard
